module.exports = __webpack_public_path__ + "static/media/cloud-download-alt.a2d8a9fb.svg";